import SalonBusinessCpaTopicPage from "./SalonBusinessCpaTopicPage";

export default function SalonBusinessCpaBookkeeping() {
  return (
    <SalonBusinessCpaTopicPage
      title="Bookkeeping"
      description="Keep monthly salon records cleaner so owner reports and tax filings are easier to prepare."
      sections={[
        {
          title: "Sales review",
          body: "Match salon sales records to deposits and reports.",
          items: ["Booking sales", "Walk-in and product sales", "Refunds and discounts"],
        },
        {
          title: "Expense review",
          body: "Group everyday salon expenses into practical categories.",
          items: ["Supplies", "Rent and utilities", "Software and processing fees"],
        },
        {
          title: "Owner review",
          body: "Flag items your accountant should review with you.",
          items: ["Owner draws", "Cash deposits", "Loan or shareholder payments"],
        },
      ]}
    />
  );
}
